import { DeviceInfo,QPInfoManager } from 'qunar-react-native';
import getQpVersion from './getQpVersion';
import CryptoJS from 'crypto-js';

const { sid, uid, gid, pid, cid, vid, isIOS, isAndroid } = DeviceInfo;
const type = isIOS ? 'IOS' : isAndroid ? 'Android' : 'other';
// const hybridId = 'cmn_order_rn';

// const getClientJson = async (hybridId = 'cmn_order_rn') => ({
//     sid,
//     uid,
//     gid,
//     pid,
//     cid,
//     vid,
//     type,
//     // TODO atomversion.order 目前获取不到
//     catom: '',
//     qpVersion: await getQpVersion(hybridId),
//     pageType: 'rn',
//     scheme: DeviceInfo.scheme
// });

const getClientJson = async (hybridId = 'cmn_order_rn') => {
    return new Promise((resolve, reject) => {
        DeviceInfo.getInfo((DeviceInfoData: any) => {
            const { sid, uid, gid, pid, cid, vid, isIOS, isAndroid } = DeviceInfoData;
            const random = String(Math.floor(Math.random()*10)) + String(Math.floor(Math.random()*10));
            const wordArray = CryptoJS.enc.Utf8.parse(uid);
            const uidd = CryptoJS.enc.Base64.stringify(wordArray);
            let userData = {
                sid,
                uid:random+uidd,
                encrypt:'1',
                gid,
                pid,
                cid,
                vid,
                type: isIOS ? 'IOS' : isAndroid ? 'Android' : 'other',
                catom: '',
                pageType: 'rn',
                scheme: DeviceInfo.scheme
            };
            QPInfoManager.getQpInfo(
                hybridId,
                (qpInfo: { version: number }) => {
                    const { version } = qpInfo || {};
                    userData.qpVersion = version;
                    resolve(userData);
                },
                () => {
                    userData.qpVersion = '';
                    resolve(userData);
                }
            );
        });
    });
}

export default getClientJson;
